module.exports = __webpack_public_path__ + "static/media/cer4.694e6c6d.PNG";